export const COUNTRY_LIST = ['USA', 'Canada'];

export const COUNTRY_STATES: Record<string, string[]> = {
	USA: [
		'AL', // Alabama
		'AK', // Alaska
		'AZ', // Arizona
		'AR', // Arkansas
		'CA', // California
		'CO', // Colorado
		'CT', // Connecticut
		'DE', // Delaware
		'FL', // Florida
		'GA', // Georgia
		'HI', // Hawaii
		'ID', // Idaho
		'IL', // Illinois
		'IN', // Indiana
		'IA', // Iowa
		'KS', // Kansas
		'KY', // Kentucky
		'LA', // Louisiana
		'ME', // Maine
		'MD', // Maryland
		'MA', // Massachusetts
		'MI', // Michigan
		'MN', // Minnesota
		'MS', // Mississippi
		'MO', // Missouri
		'MT', // Montana
		'NE', // Nebraska
		'NV', // Nevada
		'NH', // New Hampshire
		'NJ', // New Jersey
		'NM', // New Mexico
		'NY', // New York
		'NC', // North Carolina
		'ND', // North Dakota
		'OH', // Ohio
		'OK', // Oklahoma
		'OR', // Oregon
		'PA', // Pennsylvania
		'RI', // Rhode Island
		'SC', // South Carolina
		'SD', // South Dakota
		'TN', // Tennessee
		'TX', // Texas
		'UT', // Utah
		'VT', // Vermont
		'VA', // Virginia
		'WA', // Washington
		'WV', // West Virginia
		'WI', // Wisconsin
		'WY', // Wyoming
	],
	Canada: [
		'AB', // Alberta
		'BC', // British Columbia
		'MB', // Manitoba
		'NB', // New Brunswick
		'NL', // Newfoundland and Labrador
		'NS', // Nova Scotia
		'ON', // Ontario
		'PE', // Prince Edward Island
		'QC', // Quebec
		'SK', // Saskatchewan
		'NT', // Northwest Territories
		'NU', // Nunavut
		'YT', // Yukon
	],
};

export const DEFAULT_SECURITY_ROLES = {
	BYOD_ADMIN: "BYOD Admin",
	BYOD_SUPPORT: "BYOD Support",
	DEVICE_USER: "Device User",
	ORGANISATION_ADMIN: "Organization Admin",
	MANAGER: "Manager",
	HOURLY: 'Hourly employee',
};

/** Security roles hidden from all user-visible lists (dropdowns, user tables, etc.) */
export const HIDDEN_SECURITY_ROLES: readonly string[] = [
	'Mabel Support',
	'Mabel Admin',
	DEFAULT_SECURITY_ROLES.BYOD_SUPPORT,
	DEFAULT_SECURITY_ROLES.BYOD_ADMIN,
	DEFAULT_SECURITY_ROLES.DEVICE_USER,
];

export const isHiddenSecurityRole = (roleName?: string | null): boolean =>
	!!roleName && HIDDEN_SECURITY_ROLES.includes(roleName);

/** Validation rules shared by the Create and Edit security role forms */
export const SECURITY_ROLE_NAME_MIN_LENGTH = 2;
export const SECURITY_ROLE_NAME_MAX_LENGTH = 50;
export const SECURITY_ROLE_DESCRIPTION_MAX_LENGTH = 500;
export const SECURITY_ROLE_NAME_PATTERN = /^[a-zA-Z0-9\s_-]+$/;

export const SECURITY_ROLE_VALIDATION_MESSAGES = {
	NAME_REQUIRED: 'Role name is required',
	NAME_MIN: `Role name must be at least ${SECURITY_ROLE_NAME_MIN_LENGTH} characters`,
	NAME_MAX: `Role name must be at most ${SECURITY_ROLE_NAME_MAX_LENGTH} characters`,
	NAME_PATTERN: 'Role name can only contain letters, numbers, spaces, hyphens, and underscores',
	DESCRIPTION_MAX: `Description must be at most ${SECURITY_ROLE_DESCRIPTION_MAX_LENGTH} characters`,
};
